// ── Importaciones tal cual ──────────────────────────────
import React, { useState, useEffect } from 'react';
import { Modal, Button, ListGroup, Form } from 'react-bootstrap';
import ModalForm from '../../Modal/Modal';
import ModalListSmartpayModulesByUserRole from './ModalListSmartpayModulesByUserRole';
import SuccessAlert from '../../Alerts/SuccessAlert';
import ErrorAlert from '../../Alerts/ErrorAlert';
import { RenderIf } from '../../utils/RenderIf';
import { UsersFetchAPI } from '../../../api/Users';
import { SmartpayModulesFetchAPI } from '../../../api/SmartPay.Modules';


/* ── ICONS ── */
const IcoRoles  = ()=><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>;
const IcoX      = ()=><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;
const IcoList   = ()=><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>;
const IcoEye    = ()=><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>;
const IcoUser   = ()=><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>;
const IcoShield = ()=><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>;

/* ════════════════════════════════════════════════════════
   COMPONENT — lógica 100% original, nuevo shell visual
════════════════════════════════════════════════════════ */
const ModalRoles = ({ user, setEventHandler, eventHandler, businessRoles, showModal, setShowModal, token }) => {



  /* ════════════════════════════════════
     LÓGICA ORIGINAL — 100% INTACTA
  ════════════════════════════════════ */
  const [showInternalModal, setShowInternalModal]                                     = useState(false);
  const [showListSmartPayModuleModal, setShowListSmartPayModuleModal]                 = useState(false);
  const [showAsingSmartPayModuleModal, setShowAsingSmartPayModuleModal]               = useState(false);
  const [initialFormValues, setInitialFormValues]                                     = useState([
    { type: 'text',     name: 'name',        placeholder: 'Nombre',     label: 'Nombre',     required: true },
    { type: 'textarea', name: 'description', placeholder: 'Descripcion', label: 'Descripcion', required: true },
  ]);
  const [initialFormValuesAsingSmartPayModule, setInitialFormValuesAsingSmartPayModule] = useState([
    { type: 'select', name: 'module_id', placeholder: 'Modulo', label: 'Modulo', required: true, options: [] },
  ]);
  const [smartpayModules, setSmartpayModules] = useState([
    { module_code: "", module_id: 0, module_name: "", permissions: [] }
  ]);
  const [smartPayModules, setSmartPayModules] = useState([]);
  const [formData, setFormData] = useState({
    name: '',
    business_id: user.business.id,
    module_id: 0,
    role_id: 0
  });
  const [rolSelected, setSelectedRol] = useState({
    id: 0, name: '', description: '', isdefault: false,
  });

  const populateList = () => {
    const list = businessRoles.map((role) => (
      <ListGroup.Item
        as="li"
        className="d-flex justify-content-between align-items-start"
        key={role.id}
      >
        <div className="ms-2 me-auto">
          <div className="fw-bold">{role.name}</div>
        </div>
        <RenderIf isTrue={role.business_id !== null}>
          <div className="m-1">
            <button
              className="btn btn-outline-info btn-sm border-0"
              onClick={async () => { setSelectedRol({ ...role, isdefault: false }); getSmartpayModulesByRole(role); setShowListSmartPayModuleModal(true); }}
            >
              <i className="uil uil-list-ol" />
            </button>
          </div>
        </RenderIf>
        <RenderIf isTrue={role.business_id === null}>
          <div className="m-1">
            <button
              className="btn btn-outline-success btn-sm border-0"
              onClick={async () => { setSelectedRol({ ...role, isdefault: true }); getSmartpayModulesByRole(role); setShowListSmartPayModuleModal(true); }}
            >
              <i className="uil uil-eye" />
            </button>
          </div>
        </RenderIf>
      </ListGroup.Item>
    ));
    return list;
  };

  const handleFieldChange = (fieldName, value) => {
    setFormData(prevData => ({ ...prevData, [fieldName]: value }));
  };

  const newBusinessRole = async (e) => {
    e.preventDefault();
    try {
      const res = await UsersFetchAPI.createBusinessUserRole(formData, token);
      if (res.status === 200) {
        SuccessAlert('Rol creado correctamente');
        setEventHandler(1);
      }
    } catch (error) {
      ErrorAlert('Error al crear el rol');
    }
  };

  const getSmartpayModules = async () => {
    try {
      const res = await SmartpayModulesFetchAPI.getSmartpayModules(token);
      setSmartpayModules(res.data.modules);
      initialFormValuesAsingSmartPayModule[0].options = res.data.modules.map(module => (
        { value: module.id, label: module.name }
      ));
      initialFormValuesAsingSmartPayModule[0].options.unshift({ value: 0, label: 'Seleccione un modulo...' });
      setInitialFormValuesAsingSmartPayModule(initialFormValuesAsingSmartPayModule);
    } catch (error) {
      setSmartpayModules([]);
    }
  };

  const getSmartpayModulesByRole = async (role) => {
    try {
      const res = await SmartpayModulesFetchAPI.getSmartpayModulesByRole(role.id, token);
      setSmartPayModules(res.data.modules);
    } catch (err) {
      setSmartPayModules([]);
    }
  };

  useEffect(() => {
    setEventHandler(0);
    setFormData({ name: '', business_id: user.business.id });
    getSmartpayModules();
    getSmartpayModulesByRole(rolSelected);
  }, [eventHandler]);
  /* ════════════════════════════════════
     FIN LÓGICA ORIGINAL
  ════════════════════════════════════ */

  /* ── render roles como cards (nuevo visual, misma lógica) ── */
  const renderRoleCards = () => {
    if (!businessRoles || businessRoles.length === 0) {
      return (
        <div className="mrl-empty">
          <div className="mrl-empty-icon"><IcoRoles /></div>
          <p className="mrl-empty-text">No hay roles registrados aún.</p>
        </div>
      );
    }
    return businessRoles.map((role, i) => {
      const isCustom = role.business_id !== null;
      return (
        <div
          className="mrl-role-card"
          key={role.id || i}
          style={{ animationDelay: `${i * 0.04}s` }}
        >
          {/* avatar */}
          <div className={`mrl-role-avatar ${isCustom ? '' : 'system'}`}>
            {isCustom ? <IcoUser /> : <IcoShield />}
          </div>

          {/* info */}
          <div className="mrl-role-body">
            <div className="mrl-role-name">{role.name}</div>
            <div className={`mrl-role-type ${isCustom ? 'custom' : 'system'}`}>
              {isCustom ? 'Rol personalizado' : 'Rol del sistema'}
            </div>
          </div>

          {/* acciones — lógica original intacta */}
          <div className="mrl-role-actions">
            <RenderIf isTrue={isCustom}>
              <button
                className="mrl-btn-action mrl-btn-modules"
                onClick={async () => { setSelectedRol({ ...role, isdefault: false }); getSmartpayModulesByRole(role); setShowListSmartPayModuleModal(true); }}
              >
                <IcoList /> Módulos
              </button>
            </RenderIf>
            <RenderIf isTrue={!isCustom}>
              <button
                className="mrl-btn-action mrl-btn-view"
                onClick={async () => { setSelectedRol({ ...role, isdefault: true }); getSmartpayModulesByRole(role); setShowListSmartPayModuleModal(true); }}
              >
                <IcoEye /> Ver
              </button>
            </RenderIf>
          </div>
        </div>
      );
    });
  };

  /* ══════════════════════════════════
     RENDER
  ══════════════════════════════════ */
  return (
    <>
      {/* ── TRIGGER ── */}
      {/* <button className="mrl-trigger" type="button" onClick={() => setShowModal(true)}>
        <IcoRoles /> Roles
      </button> */}

      {/* ── Bootstrap Modal (importación original) ── */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="large"
        centered
        dialogClassName="mrl-dialog"
      >
        <Modal.Header>
          <div className="mrl-header">
            <div className="mrl-header-icon"><IcoRoles /></div>
            <div className="mrl-header-info">
              <div className="mrl-header-title">
                Roles
                <span className="mrl-count">{businessRoles?.length ?? 0}</span>
              </div>
              <div className="mrl-header-sub">Gestión de roles y permisos del negocio</div>
            </div>
            <button className="mrl-header-close" type="button" onClick={() => setShowModal(false)}>
              <IcoX />
            </button>
          </div>
        </Modal.Header>

        <Modal.Body>
          <div className="mrl-body">

            {/* toolbar: sección label + ModalForm (crear rol) — lógica original intacta */}
            <div className="mrl-toolbar">
              <span className="mrl-section-label">Roles registrados</span>
              <ModalForm
                modal_body={initialFormValues}
                modal_header_text="Crear nuevo rol"
                button_text="Crear"
                initialFormValues={formData}
                formType="addForm"
                buttonModal={true}
                setEventHandler={setEventHandler}
                eventHandle={eventHandler}
                submit={newBusinessRole}
                handleFieldChange={handleFieldChange}
                setShowModal={setShowInternalModal}
                showModal={showInternalModal}
              />
            </div>

            {/* lista de roles como cards */}
            <div className="mrl-list">
              {renderRoleCards()}
            </div>

            {/* ListGroup oculto — preserva la lógica original por si se necesita */}
            <div style={{ display: 'none' }}>
              <ListGroup as="ol">{populateList()}</ListGroup>
            </div>

          </div>
        </Modal.Body>

        <Modal.Footer>
          <div className="mrl-footer" style={{ width: '100%' }}>
            <button className="mrl-btn-close" type="button" onClick={() => setShowModal(false)}>
              Cerrar
            </button>
            {/* Button original oculto — mantiene la importación */}
            <Button variant="secondary" onClick={() => setShowModal(false)} style={{ display: 'none' }}>
              Cerrar
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

      {/* ── ModalListSmartpayModulesByUserRole — props originales intactos ── */}
      <ModalListSmartpayModulesByUserRole
        role={rolSelected}
        token={token}
        setShowModal={setShowListSmartPayModuleModal}
        showModal={showListSmartPayModuleModal}
        handleFieldChange={handleFieldChange}
        initialFormValues={initialFormValuesAsingSmartPayModule}
        formData={formData}
        showAsingSmartPayModuleModal={showAsingSmartPayModuleModal}
        setShowAsingSmartPayModuleModal={setShowAsingSmartPayModuleModal}
        setEventHandler={setEventHandler}
        eventHandler={eventHandler}
        smartPayModules={smartPayModules}
        business={user.business}
      />
    </>
  );
};

export default ModalRoles;